import React from 'react';
import { FaCheckCircle, FaShoppingBag, FaUser } from 'react-icons/fa';

const OrderSuccessModal = ({ isOpen, onClose, orderId, onContinueShopping, onViewOrders }) => {
  if (!isOpen) return null;

  return (
    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-0 shadow-lg">
          <div className="modal-body text-center p-5">
            {/* Success Icon */}
            <div className="mb-4">
              <FaCheckCircle size={80} color="#28a745" />
            </div>

            {/* Success Message */}
            <h2 className="modal-title mb-3" style={{ color: '#28a745', fontWeight: 700 }}>
              Order Placed Successfully!
            </h2>

            <p className="mb-4 text-muted">
              Thank you for your order. Your order has been placed successfully and is being processed.
            </p>

            {/* Order ID */}
            <div className="bg-light rounded p-3 mb-4">
              <h5 className="mb-1">Order ID</h5>
              <p className="h4 text-primary mb-0" style={{ fontFamily: 'monospace' }}>
                #{orderId}
              </p>
            </div>

            {/* Action Buttons */}
            <div className="d-flex gap-3 justify-content-center flex-wrap">
              <button
                className="btn btn-primary px-4 py-2"
                onClick={onViewOrders}
                style={{ minWidth: '140px' }}
              >
                <FaUser className="me-2" />
                View Orders
              </button>
              <button
                className="btn btn-outline-primary px-4 py-2"
                onClick={onContinueShopping}
                style={{ minWidth: '140px' }}
              >
                <FaShoppingBag className="me-2" />
                Continue Shopping
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccessModal;